import {
	IGetModifierInfo,
	IGetModifierInfoV2,
	IGetModifierRestaurantProperties,
	IGetModifierRestaurantPropertiesArguments,
	IUpdateModifierRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForModifier,
	ICreateModifier,
	ICreateModifierV2,
	IUpdateModifier,
	IUpdateModifierV2,
	IGetPaginatedModifiers,
	IModifiersByCustomerV2,
	IModifiersByRestaurantV2,
	IGetPaginatedModifiersByCustomerV2,
	IGetPaginatedModifiersByRestaurantV2,
	IModifiers,
	IGetModifierPositionList,
	IUpdateModifierPositions,
	IGetModifierPortionInfo,
	IGetModifierRestaurantPortions,
	IGetModifierRestaurantPortionsArguments,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

// Menu v1
const serviceGetModifierInfo = (modifierID: string): Promise<IGetModifierInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Modifiers/${modifierID}` });
};
// Menu v1
// Menu v2
const serviceGetModifierInfoV2 = (modifierID: string): Promise<IGetModifierInfoV2> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/modifiers/${modifierID}` });
};
// Menu v2

// Menu v2
const serviceGetModifierRestaurantProperties = (
	args: IGetModifierRestaurantPropertiesArguments,
): Promise<IGetModifierRestaurantProperties> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/restaurant-modifiers/${args.modifierId}`,
	});
};

const serviceUpdateModifierRestaurantProperties = (
	data: IUpdateModifierRestaurantProperties,
): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/restaurants/${data.restaurantId}/restaurant-modifiers/${data.modifierId}`,
		data,
	});
};

const serviceUpdateModifierRestaurantPropertiesAsPatch = (
	data: IUpdateRestaurantPropertiesAsPatchForModifier,
): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/restaurant-modifiers/${data.modifierId}`, data });
};

// Menu v2

// Menu v1
const serviceCreateModifier = (data: ICreateModifier): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Modifiers`, data });
};
// Menu v1
// Menu v2
const serviceCreateModifierV2 = (data: ICreateModifierV2): Promise<AxiosResponse<{ id: string }>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/modifiers`, data });
};
// Menu v2

// Menu v1
const serviceUpdateModifier = (data: IUpdateModifier): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Modifiers/${data.id}`, data });
};
// Menu v1
// Menu v2
const serviceUpdateModifierV2 = (data: IUpdateModifierV2): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/modifiers/${data.id}`, data });
};
// Menu v2

// Menu v1
const serviceGetPaginatedModifiers = (args: IGetPaginatedModifiers): Promise<AxiosResponse<IModifiers>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Modifiers/filtered`, data: args });
};
// Menu v1
// Menu v2
const serviceGetPaginatedModifiersByCustomerV2 = (
	args: IGetPaginatedModifiersByCustomerV2,
): Promise<AxiosResponse<IModifiersByCustomerV2>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/modifiers:search`, data: args });
};

const serviceGetPaginatedModifiersByRestaurantV2 = (
	args: IGetPaginatedModifiersByRestaurantV2,
): Promise<AxiosResponse<IModifiersByRestaurantV2>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/restaurant-modifiers:search`, data: args });
};
// Menu v2

// Menu v1
const serviceDeleteModifier = (modifierID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Modifiers/${modifierID}` });
};
// Menu v1
// Menu v2
const serviceDeleteModifierV2 = (modifierID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/v2/modifiers/${modifierID}`,
	});
};
// Menu v2
const serviceGetModifierPositionList = (modifierGroupId: string): Promise<IGetModifierPositionList> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/Modifiers/positionList?modifierGroupId=${modifierGroupId}`,
	});
};

const serviceUpdateModifierPositions = (data: IUpdateModifierPositions): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Modifiers/changePositions`, data });
};

const serviceUpdateRestaurantsInModifier = (data: {
	modifierId: string;
	restaurantIds: string[];
}): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/modifiers:update-restaurants`, data });
};

const serviceGetModifierPortionInfo = (portionId: string): Promise<IGetModifierPortionInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/modifiers/portions/${portionId}` });
};

const serviceGetModifierRestaurantPortions = (
	args: IGetModifierRestaurantPortionsArguments,
): Promise<IGetModifierRestaurantPortions> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/modifiers/${args.modifierId}/portions`,
	});
};

const serviceGetModifierPhotos = (args: {
	ids: string[];
	size: 1 | 2 | 3;
}): Promise<
	AxiosResponse<{
		files: {
			id: string;
			preSignedUrl: Nullable<string>;
		}[];
	}>
> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/modifier-photos:search`, data: args });
};

export {
	serviceGetModifierInfo,
	serviceGetModifierInfoV2,
	serviceGetModifierRestaurantProperties,
	serviceUpdateModifierRestaurantProperties,
	serviceUpdateModifierRestaurantPropertiesAsPatch,
	serviceCreateModifier,
	serviceCreateModifierV2,
	serviceUpdateModifier,
	serviceUpdateModifierV2,
	serviceGetPaginatedModifiers,
	serviceGetPaginatedModifiersByCustomerV2,
	serviceGetPaginatedModifiersByRestaurantV2,
	serviceDeleteModifier,
	serviceDeleteModifierV2,
	serviceGetModifierPositionList,
	serviceUpdateModifierPositions,
	serviceUpdateRestaurantsInModifier,
	serviceGetModifierPortionInfo,
	serviceGetModifierRestaurantPortions,
	serviceGetModifierPhotos,
};
